<!-- Verify identity page heading -->
<gds-heading
  [data]="{
    heading:
      pageLabels?.['com.udx.account.onetimepasscode.stepheader'] ||
      'Verify your identity',
  }"
  tagtype="h1"
  classes="heading-3"
>
</gds-heading>
<gds-spacer classes="spacer-70"></gds-spacer>
<!-- Verify identity supporting description -->
<gds-body
  [data]="{
    description: getFormattedDescription(),
  }"
  class="B1-W2"
></gds-body>
<gds-spacer classes="spacer-50"></gds-spacer>

<!-- Account verification help accordion -->
<gds-accordion
  [data]="{
    subheading:
      pageLabels?.['com.udx.account.onetimepasscode.help_toggle_label'] ||
      'Need help verifying your identity?',
    headerOption: 'secondary',
    option: 'option1',
    disabled: false,
  }"
>
  <gds-body
    [data]="{
      description:
        pageLabels?.['com.udx.account.onetimepasscode.help_description'] ||
        'If you did not receive the code, please check your spam folder or request a new code. For further assistance, contact Guest Services.',
    }"
    class="B1-W2"
  ></gds-body>
  <gds-spacer classes="spacer-20"></gds-spacer>
  <gds-heading
    [data]="{
      heading:
        pageLabels?.[
          'com.udx.account.onetimepasscode.guest_services_support'
        ] || 'Guest Services Support',
    }"
    classes="heading-13"
  >
  </gds-heading>
  <gds-spacer classes="spacer-20"></gds-spacer>
  <gds-heading
    [data]="{
      heading:
        pageLabels?.['com.udx.account.onetimepasscode.guest_services_call'] ||
        'Call <a href=&quot;tel:+18007756750&quot;>+1-800-775-6750</a>',
    }"
    classes="heading-13 heading-hover-underline"
    appLinkSpacebarActivation
  >
  </gds-heading>
</gds-accordion>
<gds-spacer classes="spacer-70"></gds-spacer>

<!-- Verify identity CTA buttons -->
<div class="action-bar">
  <gds-buttons
    [data]="{
      type: 'primary',
      href: emailLinkUrl,
      label:
        pageLabels?.['com.udx.account.onetimepasscode.button_email_code'] ||
        'Email me a code',
      disabled: !email(),
      target: '',
    }"
    (buttonClicked)="onEmailCode()"
    (keydown)="onSpacebarPress($event)"
  >
  </gds-buttons>
</div>
<gds-spacer classes="spacer-120"></gds-spacer>
